export default __webpack_public_path__ + "static/media/bN.09f6def5.svg";